import type { FC } from 'react';
import { Trips } from '@/components/trips/index.tsx';

export const TripDetailPage: FC = () => <Trips />;
